"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ = require(".");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Use as a container for `GlobalHeaderIcon` components. The
 * section will appear on the right-hand side of the header
 * and will shrink to fit.
 */


var GlobalHeaderIcons = function GlobalHeaderIcons(props) {
  return _react2.default.createElement(_.GlobalHeaderSection, _extends({
    align: "end",
    shrinkToFit: true
  }, props));
};

exports.default = GlobalHeaderIcons;